import React, { Component } from "react";
import { connect } from "react-redux";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { assessmentActions } from "../../../_actions";
import HeaderTransprent from "../Home/Component/HeaderTransprent";
import DownloadButton from "../../../components/UI/DownloadButton";
import Ready from "../../../components/Ready";
import Footer from "../Home/Component/Footer";
import { FiDownload } from 'react-icons/fi';
import { Helmet } from "react-helmet";

class ExploreResearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBlog: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let data = {
      keyWord: "",
      pageNo: 1,
      size: 100000,
    }
    this.props.dispatch(assessmentActions.getTalentBlogList(data));

    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
      delay: 100,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.assessment.getTalentBlogListSuccess) {
      return {
        ...nextProps,
        notFoundText: "Success!",
      };
    }
    if (nextProps.assessment.getTalentBlogListFailed) {
      return {
        ...nextProps,
        notFoundText: "Failure!",
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  // handleReadMore = (itemId) => {
  //     const { history } = this.props;
  //     history.push(`/assessment/blogdetail/${itemId}`);
  //     console.log('itemIditemIditemIditemIditemIditemIditemIditemIditemId', itemId);
  // };

  handleReadMore = blog => {
    this.setState({ selectedBlog: blog });
    if (blog && blog.id) {
      let namePath = blog.id;
      this.props.history.push({
        pathname: "/assessment/blogdetails/" + namePath,
        state: { selectedBlog: blog }
      });
    }

  };

  handleRedirect = (path) => {
    this.props.history.push(path);
  };

  gotoPage = (field) => {
    let { assessment } = this.props;
    let { userAssessmentUserProfileData } = assessment;

    if (field === "my-cart") {
      if (
        !(userAssessmentUserProfileData && userAssessmentUserProfileData.email)
      ) {
        this.props.history.push(`/assessment/` + "sign-in");
      } else {
        this.props.history.push(`/assessment/` + field);
      }
    } else {
      this.props.history.push(`/assessment/` + field);
    }
  };

  handleSignInPage = () => {
    localStorage.removeItem("route");
    localStorage.setItem("route", this.props.history.location.pathname);
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem("route");
      localStorage.setItem("route", `/assessment/` + field);
      this.props.history.push(`/assessment/sign-in`);
    }
  };

  render() {

    let { assessment } = this.props;
    let { userAssessmentUserProfileData, getAssessmentCartCountData, getAssessmentPackagesShortListData } = assessment;

    const cards = [
      {
        image: '/ResearchPaper/finding-the-missing-link.webp',
        title: 'Finding the Missing Link',
        para: ' The Role of Individual Accountability in Enhancing Employee Engagement for India’s Pharmaceutical Sector',
        pdf: '/HR-2856-ACR1.pdf'
      },
      {
        image: '/ResearchPaper/the-talentplus-strengths-report-reliability-and-validity.webp',
        title: 'The TalentPlus Strength Report – Reliability and Validity',
        pdf: '/EMRN30811.pdf'
      }
    ];

    return (
      <div>

        <Helmet>
          <meta charSet="utf-8" />
          <title>Explore Our Research | TalentPlusStrengths Blog</title>
          <meta name="description" content="Explore expert insights on strengths-based growth, leadership, and career success. Stay informed with our latest blogs and guides." />
          <meta name="keywords" content="Strengths blog, career development, leadership coaching, self-improvement, growth strategies" />
          <meta name="author" content="TalentPlusStrengths" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta property="og:title" content="Explore Our Research | TalentPlusStrengths Blog" />
          <meta property="og:description" content="Discover expert insights on strengths-based growth, leadership, and career success. Read our latest blogs and guides." />
          <meta property="og:image" content="https://talentplusstrengths.com/img/og-image.jpg" />
          <meta property="og:url" content="https://talentplusstrengths.com/#/assessment/blog" />
          <meta property="og:type" content="website" />
          <link rel="canonical" href="https://talentplusstrengths.com/#/assessment/blog" />
        </Helmet>

        <section
          className="bg-[#2196F3]/10 w-full h-auto  bg-cover bg-no-repeat bg-right "
          style={{
            backgroundImage: `url('/img/assessment/bg-gradient.webp')`,
          }}
        >
          <HeaderTransprent
            handleSignInPage={this.handleSignInPage}
            userDetails={userAssessmentUserProfileData}
            logout={this.logout}
            gotoPage={this.gotoPage}
            cartCount={getAssessmentCartCountData ? getAssessmentCartCountData : 0}
            props2={this.props}
            prodList={getAssessmentPackagesShortListData}
            gotoMyAccount={this.gotoMyAccount}
          />

          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full gap-10 px-4 py-6 mx-auto md:pt-10 md:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 ">
              <div className="flex flex-col justify-center w-full h-full pt-10 pb-10 mx-auto my-auto space-y-4 text-center md:pb-10 md:pt-0 md:text-center ">
                {/* <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest ">Employer Solutions</p> */}
                <h1
                  data-aos="fade-up"
                  className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold text-[#212121]  capitalize"
                >Research and Insights</h1>
                <div data-aos="fade-up" className="text-base md:text-lg flex text-[#212121] items-center justify-center">
                  <p className="cursor-pointer">Discover impactful studies, innovative ideas, and data-driven insights from our research team.</p>
                </div>

              </div>

            </div>
          </div>
        </section>

        {/* <div className="grid w-full h-full grid-cols-1 gap-6 px-4 py-10 mx-auto 2xl:gap-10 lg:gap-10 md:py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:grid-cols-3 md:grid-cols-2">
          {cards.map((card, index) => (
            <div key={index} className="relative bg-white overflow-hidden group rounded-l-4xl pr-4 rounded-xl" style={{ boxShadow: '10px 0 20px rgba(0, 0, 0, 0.1)' }}>
              <img src={card.image} alt="Research" className="w-full object-cover" />
              <div className="absolute bottom-0 p-4 pb-8">
                <h3 className="text-white md:text-xl text-xl leading-snug font-semibold border-l-4 border-[#2196F3] ml-4 px-4">
                  {card.title}
                </h3>
              </div>
              <div className="absolute inset-0 flex justify-center items-center pb-6">
                <DownloadButton
                  label="Download Paper"
                  textcolor="text-black"
                  rounded="rounded-full"
                  width="w-full sm:w-auto"
                  bgColor="bg-[#FBC935]"
                  hoverColor="hover:bg-[#FBC935]"
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = card.pdf;
                    link.download = card.pdf.split('/').pop();
                    link.click();
                  }}
                />
              </div>
            </div>
          ))}
        </div> */}

        {/* <div class="w-full h-full px-4 py-10 mx-auto md:py-20 2xl:w-9/12 xl:w-11/12 xl:px-0">
          <div class="grid grid-cols-1 gap-6 py-10 2xl:gap-10 lg:gap-10 xl:px-0 lg:grid-cols-3 md:grid-cols-2">
            {cards.map((card, index) => (
              <div class="relative rounded-xl overflow-hidden shadow-lg" >
                <img src={card.image} alt="Paper Image" class="w-full" />
                <div class="absolute inset-0 flex flex-col items-start justify-start bottom-0 p-6">
                  <div className="flex flex-col items-start justify-start  border-l-4 border-[#2196F3] ml-4">
                    <h3 class="text-left text-white md:text-3xl text-2xl leading-tight font-semibold pl-4">{card.title}</h3>
                    <p class="text-left text-white leading-snug font-semibold px-4 pt-2">{card.para}</p>
                  </div>
                  <div className="flex items-start justify-start pl-4">
                    <DownloadButton
                      label="Download Paper"
                      textcolor="text-black"
                      rounded="rounded-lg"
                      width="w-full sm:w-auto"
                      bgColor="bg-[#FBC935]"
                      icon={FiDownload}
                      hoverColor="hover:bg-[#e2b530]"
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = card.pdf;
                        link.download = card.pdf.split('/').pop();
                        link.click();
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        <div class="w-full h-full px-4 py-10 mx-auto md:py-20 2xl:w-9/12 xl:w-11/12 xl:px-0">
          <div class="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-6 py-10 2xl:gap-10 lg:gap-10 xl:px-0">
            {cards.map((card, index) => (
              <div
                key={index}
                className="relative rounded-xl overflow-hidden shadow-lg bg-cover bg-center h-80"
                style={{ backgroundImage: `url(${card.image})` }}
              >
                <div className="absolute inset-0 bg-black/40 flex flex-col justify-end p-6">
                  <div className="flex flex-col items-start border-l-4 border-[#2196F3] ml-4">
                    <h3 className="text-left text-white md:text-3xl text-2xl leading-tight font-semibold pl-4">
                      {card.title}
                    </h3>
                    <p className="text-left text-white leading-snug font-semibold px-4 pt-2">
                      {card.para}
                    </p>
                  </div>
                  <div className="flex items-start justify-start pl-4 mt-4">
                    <DownloadButton
                      label="Download Paper"
                      textcolor="text-black"
                      rounded="rounded-lg"
                      width="w-full sm:w-auto"
                      bgColor="bg-[#FBC935]"
                      icon={FiDownload}
                      hoverColor="hover:bg-[#e2b530]"
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = card.pdf;
                        link.download = card.pdf.split('/').pop();
                        link.click();
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>

        <Ready />

        <Footer
          props2={this.props}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />

      </div >
    );
  }
}



function mapStateToProps(state) {
  //console.log("state  ", state);
  const { assessment } = state;
  return {
    assessment
  };
}

export default connect(mapStateToProps)(ExploreResearch);